import { cn } from "@omni/utils/styles";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import { useDeliveryItemContext } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/context/deliveryItem.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const SupplierInfoLink = ({ className }: Props) => {
    const { t } = useGranite();

    const { xfPath } = useDeliveryItemContext();

    if (!xfPath) return null;

    return (
        <Anchor
            color={"link"}
            className={cn("tw:text-sm! tw:p-0 tw:font-light tw:m-0", className)}
            href={"#supplier-info"}
        >
            {t("ecommerce.label.supplierInformation")}
        </Anchor>
    );
};
